import React from 'react'
import style from '../CSS/Style.module.css'
export default function Footer() {
  return (
    <div className={style.footer}><h3>Footer</h3></div>
  )
}
